export default "__VITE_ASSET__BUvZsDPY__"